import {Component, input, InputSignal} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {RouterLink} from "@angular/router";
import {SearchObject} from "../../../core/definitions/search-object";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslatePipe} from "@ngx-translate/core";
import {MatIconButton} from "@angular/material/button";

@Component({
  selector: 'app-search-result-package-indicator',
  imports: [
    MatIcon,
    RouterLink,
    MatTooltip,
    TranslatePipe,
    MatIconButton
  ],
  templateUrl: './search-result-package-indicator.html',
  styleUrl: './search-result-package-indicator.scss'
})
export class SearchResultPackageIndicator {
  buttonInTable: InputSignal<boolean> = input(false);
  item: InputSignal<SearchObject> = input();
  packageDataIsObject: InputSignal<boolean> = input(false);

  get itemRouterLink() {
    if (this.packageDataIsObject()) {
      return ['/artifact', this.item().package_placement.package_id];
    }

    return ['/artifact', this.item()['package_placement.package_id']];
  }

  get packageName() {
    if (this.packageDataIsObject()) {
      return this.item().package_placement.package_id_value;
    }

    return this.item()['package_placement.package_id_value'];
  }
}
